<div class="learning-heading-section" role="main" id="MainTitle" tabindex="0">
  <div class="learning-title"><span class="rows">{{ titleName | uppercase}}</span> <span class="bottom-line"></span></div>
  <div class="pull-right margin_top4">
      <div *ngIf="bs.isShowAssignedFilter" class="btn-group mb-sm border-right">
          <a aria-expanded="false" href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link"><img src="assets/img/filter.svg" alt="{{bs.getResource('rbkey_LrnglstfltrImgLBL')}}" style="width: 18px;"><span id="selectedFilterAssignedType">{{assignedFilterStatus}}</span>
              <!-- <span class="caret"></span> -->
          </a>
          <ul role="menu" class="dropdown-menu animated fadeIn right">
              <li *ngFor="let item of AssignedFilterList;"><a href="javascript:void(0);" attr.action="{{item.action}}" class="hand-cursor"  (click)="filterBy(item)">{{item.name}}</a>
              </li>
          </ul>
      </div>      
      <div class="btn-group mb-sm border-right margin_right10" *ngIf="!bs.isReadAndSign && IsSortBy">
          <a aria-expanded="false" href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">
              <span>{{bs.getResource('rbkey_ByLBL_App')}} </span>{{SortByStatus}}
              <!-- <span class="caret"></span> -->
          </a>
          <ul role="menu" class="dropdown-menu animated fadeIn right">
              <li *ngFor="let sortItem of SortByList"><a href="javascript:void(0);" class="hand-cursor" (click)="sortBy(sortItem)">{{sortItem.name}}</a>
              </li>
          </ul>
      </div>

   
  <a [attr.aria-label]="bs.getResource('rbkey_CrsSrchLBL')" href="javascript:void(0);" (click)="openCloseSearch(true)" class="search-icon-heading icon-magnifier pull-right hand-cursor"></a>

  <form role="search" [ngClass]="searchFormClass">
      <div class="form-group has-feedback no-margin-b">
          <input id="searchInput" type="text" #search placeholder="{{bs.getResource('rbkey_SrchBsdNmDscrptnTpcKywrdLrnCdLBL')}}" class="form-control" (keydown.enter)="searchText($event,search.value)">
          <div data-search-dismiss="" (click)="openCloseSearch(false)" class="fa fa-times form-control-feedback remove-search hand-cursor cross-position"></div>
      </div>
  </form>
 <a aria-hidden="true" *ngIf="isShowCalendar" href="javascript:void(0);" (click)="RedToCalenderView()" class="calendar-icon-heading border-right  icon-calender pull-right hand-cursor"></a>

</div>
</div>
